import * as DialogPrimitive from '@radix-ui/react-dialog'
import { type ComponentProps, type ReactElement } from 'react'
import { XIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

function Dialog (props: ComponentProps<typeof DialogPrimitive.Root>): ReactElement {
  return <DialogPrimitive.Root {...props} />
}

function DialogTrigger (props: ComponentProps<typeof DialogPrimitive.Trigger>): ReactElement {
  return <DialogPrimitive.Trigger {...props} />
}

function DialogContent ({ className, children, ...props }: ComponentProps<typeof DialogPrimitive.Content>): ReactElement {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className='fixed inset-0 z-1000 bg-black/45' />
      <DialogPrimitive.Content
        className={cn(
          'fixed top-1/2 left-1/2 z-1000 w-full max-w-200 -translate-x-1/2 -translate-y-1/2 m-5 rounded-[10px] border border-(--bp-border) bg-(--bp-surface) shadow-(--shadow-lg) outline-none',
          className
        )}
        {...props}
      >
        {children}
        <DialogPrimitive.Close className='absolute right-4 top-4 text-(--bp-ink3) hover:text-(--bp-ink) cursor-pointer'>
          <XIcon className='size-4' />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  )
}

function DialogHeader ({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return <div className={cn('p-6 pb-2', className)} {...props} />
}

function DialogTitle ({ className, ...props }: ComponentProps<typeof DialogPrimitive.Title>): ReactElement {
  return (
    <DialogPrimitive.Title
      className={cn('text-[16px] font-bold text-(--bp-ink)', className)}
      {...props}
    />
  )
}

function DialogFooter ({ className, ...props }: ComponentProps<'div'>): ReactElement {
  return (
    <div
      className={cn(
        'flex justify-end gap-2 px-6 py-4 bg-(--bp-surface2) border-t border-(--bp-border) rounded-b-[10px]',
        className
      )}
      {...props}
    />
  )
}

export { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogFooter }
